import { SourceTypeResponse } from "api/company";

import { CompanyParams, CompanySourceTypeParams, routes } from "config/urls";

import { formatUrl } from "./formatUrl";

export function getSourceTypeLinkUrl(
  companyId: string,
  sourceType?: SourceTypeResponse
) {
  if (!sourceType) {
    return formatUrl<CompanyParams>(routes.company.link, {
      companyId,
    });
  }
  return formatUrl<CompanySourceTypeParams>(getRoute(sourceType), {
    companyId,
    sourceType: sourceType.sourceType.toLowerCase(),
  });
}

function getRoute(sourceType: SourceTypeResponse) {
  if (sourceType.displayRevisit) return routes.company.revisit;
  if (sourceType.useCustomIntro) return routes.company.customIntro;
  return routes.company.link;
}
